export enum PathParam {
  SaleId = 'saleId',
  RaffleURI = 'raffleURI',
  SalePath = 'salePath',
  StoryName = 'storyName',
}
